import * as firebase from 'firebase/app'
import 'firebase/performance'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { auth0, login } from './auth/client'
import './index.css'
require('./instrument.js')

if (process.env.NODE_ENV === 'production') {
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  }
  firebase.initializeApp(firebaseConfig)
  firebase.performance()
}

auth0
  .checkSession()
  .then(() => {
    if (window.location.pathname === '/callback') {
      auth0
        .handleRedirectCallback()
        .then(() => {
          ReactDOM.render(<App />, document.getElementById('root'))
        })
        .catch((err) => {
          console.error('Error handling redirect callback:', err)
          auth0.isAuthenticated().then((isAuthenticated) => {
            if (!isAuthenticated) {
              login()
            } else {
              ReactDOM.render(<App />, document.getElementById('root'))
            }
          })
        })
    } else {
      auth0.isAuthenticated().then((isAuthenticated) => {
        if (!isAuthenticated) {
          login()
        } else {
          ReactDOM.render(<App />, document.getElementById('root'))
        }
      })
    }
  })
  .catch((err) => {
    login()
  })
